module.exports = __webpack_public_path__ + "static/img/about5.d1cdef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about5.png
// module id = 6fpb
// module chunks = 1